import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './HeroText.css';
import iconSvg from '../assets/Group 116.svg';

const HeroText = () => {
  const [isMobile, setIsMobile] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const scrollToBrands = () => {
    const brandsSection = document.querySelector('.brands-section');
    if (brandsSection) {
      brandsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-text">
      <h1 className="hero-text__title">
        {isMobile ? (
          <>
            <img src={iconSvg} alt="" className="hero-text__icon" />
            <div className="hero-text__phrases">
              <span className="hero-text__phrase">YOUR TRAFFIC</span>
              <span className="hero-text__phrase">REAL REVENUE</span>
            </div>
          </>
        ) : (
          <>
            <span className="hero-text__phrase">YOUR TRAFFIC</span>
            <img src={iconSvg} alt="" className="hero-text__icon" />
            <span className="hero-text__phrase">REAL REVENUE</span>
          </>
        )}
      </h1>
      <p className="hero-text__subtitle">
        A performance-driven affiliate program with high-converting brands and clear, reliable reporting.
      </p>
      <div className="hero-text__buttons">
        <button 
          className="hero-text__btn hero-text__btn--brands"
          onClick={scrollToBrands}
        >
          Check out our Brands
        </button>
        <button 
          className="hero-text__btn hero-text__btn--join"
          onClick={() => history.push('/signup')}
        >
          Join WinningPartner
        </button>
      </div>
    </div>
  );
};

export default HeroText;
